





































































/* eslint-disable no-plusplus */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-explicit-any */

import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';

import Button from '@/components/Button.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Header from '@/components/Table/Header.vue';
import Row from '@/components/Table/Row.vue';
import Cell from '@/components/Table/Cell.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Modal from '@/components/Modal.vue';

import ProcessTable from '@/pages/Reconciliation/ProcessTable.vue';

@Component({
  components: {
    LayoutContent,
    Button,
    Table,
    TableBody,
    Header,
    Row,
    Cell,
    ScrollbarWrapper,
    Modal,
    ProcessTable,
  },
})

export default class ProcessIndex extends Vue {
  bank: any[] = [];
  rowsData: any[] = [];
  dataUpload: any[] = [];
  showModalRecon = false;

  eventOpenModal(e: any) {
    const data: any[] = [];
    let num = 0;
    e.data.forEach((v: any) => {
      v.Reason.forEach((i: any) => {
        num++;
        data.push({
          no: num,
          row: v.Line,
          reason: i,
        });
      });
    });
    this.rowsData = data || [];
    this.showModalRecon = !this.showModalRecon;
  }
}
